import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';

// One full-screen loader for the whole app. api/index.js calls startLoader()
// when a request goes out and stopLoader() when it finishes, so every page
// (list, detail, add, update, approve, upload...) shows the same loader
// without any page having to manage it.

let pending = 0;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn(pending > 0));

export const startLoader = () => {
  pending += 1;
  notify();
};

export const stopLoader = () => {
  pending = Math.max(0, pending - 1);
  notify();
};

// very fast requests finish before this, so the screen does not flash
const SHOW_DELAY_MS = 150;

const GlobalLoader = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let timer = null;
    const onChange = (busy) => {
      if (busy) {
        if (!timer) timer = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
      } else {
        clearTimeout(timer);
        timer = null;
        setVisible(false);
      }
    };
    listeners.add(onChange);
    // a request may already be running when this mounts
    if (pending > 0) onChange(true);
    return () => {
      listeners.delete(onChange);
      clearTimeout(timer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="global-loader" role="status" aria-live="polite" aria-label="Loading">
      <Spin size="large" />
    </div>
  );
};

export default GlobalLoader;
